export const GET_OPEN_NOTIFICATIONS = "GET_OPEN_NOTIFICATIONS"
